import React, { useMemo } from 'react';
import { classNames } from '@src/utils';
import './app-footer.scss';
var prefixCls = 'app-footer';
var AppFooter = function (props) {
    var className = useMemo(function () {
        return classNames(prefixCls, props.className);
    }, [props.className]);
    var style = useMemo(function () {
        return Object.assign({}, props.style);
    }, [props.style]);
    var footData = [
        {
            title: '为明教育',
            href: 'http://www.weimingedu.com/',
        },
        {
            title: '深圳学校',
            href: 'http://bdfz.szns.edu.cn/',
        },
        {
            title: '广州学校',
            href: 'http://www.wmxxgz.com/',
        },
        {
            title: '成都学校',
            href: 'http://www.wmxxcd.com/',
        },
        {
            title: '重庆学校',
            href: 'http://www.weimingcq.com/',
        },
        {
            title: '新津学校',
            href: 'http://www.wmxxxj.com/',
        },
        {
            title: '武汉学校',
            href: 'http://www.wmxxwh.com/',
        },
        {
            title: '贵阳学校',
            href: 'http://www.wmxxgy.com/',
        },
        {
            title: '光谷学校',
            href: 'http://www.wmjygg.net/',
        },
        {
            title: '青岛学校',
            href: 'http://www.wmjyqd.net/',
        },
        {
            title: '天津学校',
            href: 'http://www.tjwmschool.net/',
        },
        {
            title: '宝安学校',
            href: 'http://wmjyszba.com/',
        },
        {
            title: '天津西青为明学校',
            href: 'http://www.wmistj.com/',
        },
        {
            title: '六盘水学校',
            href: 'http://www.wmxxgy.com/',
        },
        {
            title: '为明幼教',
            href: 'http://www.weimingkids.com/',
        },
        {
            title: '为明蒙特梭利',
            href: 'http://www.wmec-bj.com/',
        },
    ];
    return (React.createElement("div", { className: "footer-container" },
        React.createElement("footer", { className: className + " ", style: style },
            React.createElement("ul", { className: prefixCls + "_link" }, footData.map(function (item, index) {
                return (React.createElement("li", { key: index },
                    React.createElement("a", { target: "_blank", rel: "noreferrer", href: item.href }, item.title)));
            })),
            React.createElement("span", null,
                "2014-",
                new Date().getFullYear(),
                "\u00A0\u00A9\u00A0\u5317\u4EAC\u60E0\u4E30\u5B66\u4FE1\u6559\u80B2\u79D1\u6280\u6709\u9650\u516C\u53F8",
                React.createElement("i", { style: { marginLeft: '20px' } }, "\u9E23\u8C22\uFF1A\u65B9\u4FEE\u7AF9")))));
};
export default React.memo(AppFooter);
